/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonRelay,
    JsonRelayFromJSON,
    JsonRelayFromJSONTyped,
    JsonRelayToJSON,
} from './JsonRelay';

/**
 * 
 * @export
 * @interface ApiResultOfJsonRelay
 */
export interface ApiResultOfJsonRelay {
    /**
     * 
     * @type {JsonRelay}
     * @memberof ApiResultOfJsonRelay
     */
    data?: JsonRelay;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelay
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonRelay
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelay
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelay
     */
    result?: ApiResultOfJsonRelayResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonRelayResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonRelayFromJSON(json: any): ApiResultOfJsonRelay {
    return ApiResultOfJsonRelayFromJSONTyped(json, false);
}

export function ApiResultOfJsonRelayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonRelay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonRelayFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonRelayToJSON(value?: ApiResultOfJsonRelay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonRelayToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

